import React from 'react'

const SortFilter = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/sort_filter',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill={primaryColor} fillRule='evenodd'>
      <path d='M12.5 5.6c0 .331-.258.6-.575.6H1.575A.588.588 0 0 1 1 5.6c0-.331.258-.6.575-.6h10.35c.317 0 .575.269.575.6M10.444 9.2H1.556C1.249 9.2 1 8.931 1 8.6c0-.331.249-.6.556-.6h8.888c.307 0 .556.269.556.6 0 .331-.249.6-.556.6zM8.933 12.2H1.567c-.313 0-.567-.269-.567-.6 0-.331.254-.6.567-.6h7.366c.313 0 .567.269.567.6 0 .331-.254.6-.567.6zM7.417 15.2H1.583A.592.592 0 0 1 1 14.6c0-.331.261-.6.583-.6h5.834c.322 0 .583.269.583.6 0 .331-.261.6-.583.6zM12.418 12.176a.6.6 0 0 1 .849 0l2.545 2.548a.601.601 0 0 1-.848.85l-2.546-2.549a.602.602 0 0 1 0-.85' />
      <path d='M18.358 12.176a.602.602 0 0 1 0 .85l-2.545 2.548a.6.6 0 1 1-.849-.85l2.545-2.548a.6.6 0 0 1 .85 0' />
      <path d='M15.4 5c.332 0 .6.224.6.5v9c0 .276-.268.5-.6.5-.331 0-.6-.224-.6-.5v-9c0-.276.269-.5.6-.5' />
    </g>
  </svg>
)

export default SortFilter
